import { memo } from 'react';
import { useAtomValue } from 'jotai';
import { customFieldPickerAnchorAtom, customFieldValuePickerAtom } from './state';
import FieldPickerPopover from './field-picker-popover';
import ValuePickerPopover from './value-picker-popover';

const CustomFieldFilterPopovers = () => {
  const fieldAnchor = useAtomValue(customFieldPickerAnchorAtom);
  const valuePicker = useAtomValue(customFieldValuePickerAtom);

  return (
    <>
      {fieldAnchor && <FieldPickerPopover />}
      {valuePicker && <ValuePickerPopover key={`${valuePicker.fieldId}::${valuePicker.editIndex}`} />}
    </>
  );
};

export default memo(CustomFieldFilterPopovers);
